import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import FlowChart from "./FlowChart";
import "../styles/hero.css";
import { IMAGES } from "../data/content";
import attendanceCheck from "../assets/screenshots/attendance-check.gif";

const HERO_FLOW = [
  { title: "Selfie captured", icon: "selfie" },
  { title: "Location verified", icon: "gps" },
  { title: "Attendance submitted", icon: "check" },
];

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero-inner">
        <div className="hero-content">
          <span className="eyebrow">
            <span className="eyebrow-dot" aria-hidden="true" />
            Mobile HR Management System
          </span>

          <h1 className="hero-title">
            Digitize attendance.
            <br />
            Simplify HR.
          </h1>

          <p className="hero-subtitle">
            MPeoples HRMS gives employees and organizations a centralized
            platform for attendance and day-to-day HR — with selfie and
            location-verified check-in/check-out, leave and permission
            management, payroll and payslips, and a web-based Admin Dashboard
            for HR and management.
          </p>

          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              Request a Demo
              <Icon name="arrow" size={16} />
            </Link>
            <Link to="/features" className="btn btn-secondary">
              Explore Features
            </Link>
          </div>

          {/* <div className="hero-stack">
            <span className="hero-stack-label">Built on</span>
            <div className="hero-stack-items">
              <span className="mono-tag hero-stack-item">Flutter</span>
              <span className="mono-tag hero-stack-item">React JS</span>
              <span className="mono-tag hero-stack-item">Laravel</span>
              <span className="mono-tag hero-stack-item">REST API</span>
            </div>
          </div> */}
        </div>

        <div className="hero-visual">
          {/* <div className="hero-phone">
            <div className="hero-phone-notch" aria-hidden="true" />
            <div className="hero-phone-screen" role="img" aria-label="Attendance check-in flow: selfie captured, location verified, attendance submitted">
              <span className="hero-phone-screen-label">Check-in flow</span>
              <FlowChart steps={HERO_FLOW} variant="flowchart--compact" />
            </div>
          </div> */}
          <div className="hero-phone">
            <div className="hero-phone-notch" aria-hidden="true" />
            <img
              // src={IMAGES.heroapp}
              src={attendanceCheck}
              alt="MPeoples HRMS check-in screen"
              className="hero-phone-screen"
            />
          </div>

          <div className="hero-mock hero-mock--badge">
            <Icon name="gps" size={14} />
            <span className="mono-tag">GPS + Selfie</span>
          </div>

          <div className="hero-mock hero-mock--chip">
            <span className="hero-mock-chip hero-mock-chip--positive">
              <Icon name="check" size={12} />
              Location verified
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
